import i18n from "@/i18n";
// CALENDAR-ABSENCES-V1 — single source for absence labels, roles and copy
// (Team, Schedule and Review Hours).
export const ABSENCE_TYPE_LABELS = {
    get ANNUAL_LEAVE() { return i18n.t("wf.absenceShared.ABSENCE_TYPE_LABELS.ANNUAL_LEAVE", "Annual leave"); },
    get SICK_LEAVE() { return i18n.t("wf.absenceShared.ABSENCE_TYPE_LABELS.SICK_LEAVE", "Sick leave"); },
    get UNPAID_LEAVE() { return i18n.t("wf.absenceShared.ABSENCE_TYPE_LABELS.UNPAID_LEAVE", "Unpaid leave"); },
    get OTHER_APPROVED() { return i18n.t("wf.absenceShared.ABSENCE_TYPE_LABELS.OTHER_APPROVED", "Other approved"); },
    get PREGNANCY_LEAVE() { return i18n.t("wf.absenceShared.ABSENCE_TYPE_LABELS.PREGNANCY_LEAVE", "Pregnancy leave"); },
    get PARENTAL_LEAVE() { return i18n.t("wf.absenceShared.ABSENCE_TYPE_LABELS.PARENTAL_LEAVE", "Parental leave"); },
    get TEMPORARY_CHILD_CARE_LEAVE() { return i18n.t("wf.absenceShared.ABSENCE_TYPE_LABELS.TEMPORARY_CHILD_CARE_LEAVE", "Temporary child-care leave"); },
    get OTHER_FAMILY_LEAVE() { return i18n.t("wf.absenceShared.ABSENCE_TYPE_LABELS.OTHER_FAMILY_LEAVE", "Other family leave"); },
    get PAID_LEAVE() { return i18n.t("wf.absenceShared.ABSENCE_TYPE_LABELS.PAID_LEAVE", "Paid leave"); },
};
export const ABSENCE_TYPES = Object.keys(ABSENCE_TYPE_LABELS);

export const absenceLabel = (type) => ABSENCE_TYPE_LABELS[type] || type;

// Owner rule G4 — Manager/Corporate only; Super Admin is platform management.
export const ABSENCE_AUTHORIZED_ROLES = new Set([
    "restaurant", "restaurant_admin", "corporate",
]);
export const canManageAbsences = (user) => !!(user && ABSENCE_AUTHORIZED_ROLES.has(user.role));

export const _MSG_TYPE_FACT_ONLY =
    "Recorded as a fact. MiseOne does not calculate pay or entitlement; "
    + "Averaging working-time credit follows TES 12 § 1.2.";
export const _MSG_PAID_LEAVE_HELPER =
    "Paid leave records your own classification. MiseOne does not "
    + "verify or calculate pay or entitlement.";
export const _MSG_OVERLAP =
    "This employee already has an absence covering part of these dates.";
export const _MSG_PERIOD_CLOSED =
    "This period is closed. Reopen it before changing this absence.";
export const _MSG_CLOSED_PATH =
    "Closed periods are locked. To change an absence: Reopen the period → "
    + "edit the absence → Close again. The earlier Close version and its "
    + "payroll documents stay unchanged.";
export const _MSG_ROLE_FORBIDDEN =
    "Only a manager or corporate account can change absences.";
export const _MSG_REVIEWED =
    "Some of these dates already have approved hours. Add a reason and "
    + "confirm. The review and the approved hours stay unchanged.";
export const _MSG_NO_EMPLOYMENT =
    "This employee has no active employment on the start date.";
export const _MSG_GENERIC = "Could not save the absence. Try again.";
export const _MSG_CANCEL_TITLE = "Cancel this absence?";
export const _MSG_CANCEL_BODY =
    "This removes it from current active planning but preserves "
    + "its audit history.";
export const _NOTE_HELPER = "Do not include medical details.";
export const _MSG_SHIFT_WARNING = (n) =>
    `${n} selected day${n === 1 ? " already has" : "s already have"} a planned shift. `
    + "The shift and any recorded hours stay unchanged; adjust them separately if needed.";

export const REVIEWED_CODE = "REVIEWED_HOURS_CORRECTION_REQUIRES_REASON_AND_CONFIRMATION";

export function absenceErrorCode(err) {
    const detail = err?.response?.data?.detail;
    return typeof detail === "object" ? detail?.code : null;
}

export function absenceErrorMessage(err) {
    const code = absenceErrorCode(err);
    if (code === "WORKFORCE_ABSENCE_OVERLAP") return i18n.t("wf.absenceShared._MSG_OVERLAP", _MSG_OVERLAP);
    if (code === "WORKFORCE_PERIOD_CLOSED") return i18n.t("wf.absenceShared._MSG_PERIOD_CLOSED", _MSG_PERIOD_CLOSED);
    if (code === "WORKFORCE_ABSENCE_ROLE_FORBIDDEN"
        || code === "REVIEWED_HOURS_CORRECTION_FORBIDDEN"
        || code === "WORKFORCE_OPERATIONAL_ROLE_FORBIDDEN") return i18n.t("wf.absenceShared._MSG_ROLE_FORBIDDEN", _MSG_ROLE_FORBIDDEN);
    if (code === REVIEWED_CODE) return i18n.t("wf.absenceShared._MSG_REVIEWED", _MSG_REVIEWED);
    return i18n.t("wf.absenceShared._MSG_GENERIC", _MSG_GENERIC);
}

// Existing audited evidence classification for an absence type (G3).
export function evidenceKindForAbsence(type) {
    if (type === "SICK_LEAVE") return "SICK_CONTINUITY";
    if (type === "PREGNANCY_LEAVE" || type === "PARENTAL_LEAVE") return "FAMILY_LEAVE_CLASSIFICATION";
    if (["OTHER_FAMILY_LEAVE", "PAID_LEAVE", "UNPAID_LEAVE"].includes(type)) {
        return "ABSENCE_BASIS_CLASSIFICATION";
    }
    return null;
}

export function shiftDaysInRange(shiftDates, start, end) {
    if (!shiftDates || !start || !end || start > end) return 0;
    let n = 0;
    shiftDates.forEach((d) => { if (d >= start && d <= end) n += 1; });
    return n;
}
